import MedicineDictionary from '@/entities/medicine-dictionary/model/medicineDictionary.model';
import { createMedicineDictionaryDetailUrl } from '@/entities/medicine-dictionary/util';
import useGetKeywordIntegratedSearchMedicineDictionary from '@/hooks/search/useGetKeywordIntegratedSearchMedicineDictionary';
import useCustomRouter from '@/hooks/useCustomRouter';
import { ROUTES } from '@/types/common';

interface SearchTotalMedicineDictionaryViewModel {
  medicineDictionaryItems: Array<MedicineDictionary>;
  currentPage: number;
  totalPage: number;
  queries: { keyword: string; page: string };
  paginationBaseUrl: string;
  onClickMedicineDictionary: (medicineDictionary: MedicineDictionary) => () => void;
}

const useSearchTotalMedicineDictionaryViewModel = (): SearchTotalMedicineDictionaryViewModel => {
  const { router } = useCustomRouter();
  const queries = router.isReady ? (router.query as { keyword: string; page: string }) : { keyword: '', page: '1' };
  const { page = '1' } = queries;

  const currentPage = Number(page) || 1;

  const { keywordSearchMedicineDictionary, totalPage } = useGetKeywordIntegratedSearchMedicineDictionary({
    keyword: undefined,
    enabled: true,
    limit: 10,
    page: currentPage,
  });

  const medicineDictionaryItems = keywordSearchMedicineDictionary?.elements || [];
  const paginationBaseUrl = ROUTES.MEDICINE_DICTIONARY.HOME.path;
  const onClickMedicineDictionary = (medicineDictionary: MedicineDictionary) => () => {
    router.push(createMedicineDictionaryDetailUrl(medicineDictionary));
  };

  return {
    medicineDictionaryItems,
    currentPage,
    totalPage,
    queries,
    paginationBaseUrl,
    onClickMedicineDictionary,
  };
};

export default useSearchTotalMedicineDictionaryViewModel;
